'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash.tonumber');

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  tag: _react.PropTypes.string,
  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  max: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  animated: _react.PropTypes.bool,
  striped: _react.PropTypes.bool,
  color: _react.PropTypes.string,
  className: _react.PropTypes.string,
  cssModule: _react.PropTypes.object
};

var defaultProps = {
  tag: 'progress',
  value: 0,
  max: 100
};

var Progress = function Progress(props) {
  var className = props.className;
  var cssModule = props.cssModule;
  var value = props.value;
  var max = props.max;
  var animated = props.animated;
  var striped = props.striped;
  var color = props.color;
  var Tag = props.tag;

  var attributes = _objectWithoutProperties(props, ['className', 'cssModule', 'value', 'max', 'animated', 'striped', 'color', 'tag']);

  var percent = (0, _lodash2.default)(value) / (0, _lodash2.default)(max) * 100;

  var nonProgressClasses = (0, _utils.mapToCssModules)((0, _classnames2.default)(className, 'progress', animated ? 'progress-animated' : null), cssModule);

  var progressClasses = (0, _utils.mapToCssModules)((0, _classnames2.default)(nonProgressClasses, color ? 'progress-' + color : null, striped || animated ? 'progress-striped' : null), cssModule);

  var fallbackClasses = (0, _utils.mapToCssModules)((0, _classnames2.default)('progress-bar', color ? 'progress-' + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);

  var fallbackFill = _react2.default.createElement('span', {
    className: fallbackClasses,
    style: { width: percent + '%' },
    role: 'progressbar',
    'aria-valuenow': value,
    'aria-valuemin': '0',
    'aria-valuemax': max
  });

  if (Tag === 'progress') {
    return _react2.default.createElement(
      Tag,
      _extends({}, attributes, { className: progressClasses, value: value, max: max }),
      _react2.default.createElement('div', { className: nonProgressClasses, children: fallbackFill })
    );
  }

  return _react2.default.createElement(Tag, _extends({}, attributes, { className: nonProgressClasses, children: fallbackFill }));
};

Progress.propTypes = propTypes;
Progress.defaultProps = defaultProps;

exports.default = Progress;


//////////////////
// WEBPACK FOOTER
// ./~/reactstrap/lib/Progress.js
// module id = 429
// module chunks = 0